module.exports = __webpack_public_path__ + "img/fb.bbac336e.svg";